import React from 'react';
import { Navigate } from 'react-router-dom';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const adminToken = localStorage.getItem('admin_token');
  // REACT_APP_ADMIN_DEV_LOGIN skips the login page in local dev. Pair it with ADMIN_DEV_EMAIL on the backend.
  const devLogin = process.env.REACT_APP_ADMIN_DEV_LOGIN === 'true';

  if (!adminToken && !devLogin) {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
